"use client";

import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import { LegalDocument } from "@/components/legal/legal-document";
import { GRIGORETS_PRIVACY_SECTIONS, PRIVACY_SECTIONS } from "@/components/legal/sections";

export function PrivacyPage() {
  const { flavor, brand } = useSiteFlavor();

  return <LegalDocument namespace="privacy" sections={brand.legalProfile === "grigorets" ? GRIGORETS_PRIVACY_SECTIONS : PRIVACY_SECTIONS[flavor]} />;
}
